import { render, staticRenderFns } from "./CriteriaTable.vue?vue&type=template&id=09f9a1fd"
import script from "./CriteriaTable.vue?vue&type=script&lang=js"
export * from "./CriteriaTable.vue?vue&type=script&lang=js"
import style0 from "./CriteriaTable.vue?vue&type=style&index=0&id=09f9a1fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports